var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"outer_loading"},[_c('van-loading',{staticClass:"van_loading",attrs:{"type":"spinner","size":"20px"}},[_c('span',{staticClass:"loading_text"},[_vm._v("加载中...")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }